import React from 'react';

import { FishCatchesIcon } from '../../../Icons/FishCatchesIcon';
import { Text } from '../../../Text/Text';

export const PostImagePlaceholder = () => {
  return (
    <section className="flex size-full flex-wrap content-center justify-center bg-twilight">
      <FishCatchesIcon className="w-full text-lake-fog" size={160} title="fish catches icon" />
      <Text className="font-semibold text-sea-foam">No photo added</Text>
    </section>
  );
};
